// extracted by mini-css-extract-plugin
export var aiStarIcon = "_tc-2";
export var container = "_tc-4";
export var dismissButton = "_tc-3";
export var hasPaddingBottom = "_tc-6";
export var last = "_tc-e";
export var scrollbarThumb = "_tc-c";
export var scrollbarTrack = "_tc-b";
export var selected = "_tc-9";
export var spin = "_tc-1";
export var spinning = "_tc-0";
export var suggestionItem = "_tc-d";
export var suggestionsPanel = "_tc-5";
export var tonePill = "_tc-8";
export var tonesContainer = "_tc-7";
export var unselected = "_tc-a";